import axios from 'axios';

export class AuthorizeService {
	_callbacks = [];
	_nextSubscriptionId = 0;
	_user = null;
	_isAuthenticated = false;

	// By default pop ups are disabled because they don't work properly on Edge.
	// If you want to enable pop up authentication simply set this flag to false.
	_popUpDisabled = true;

	async isAuthenticated() {
		try {
			await axios.get('api/auth/user')
			this._isAuthenticated = true;
		} catch (error) {
			this._isAuthenticated = false;
		}

		return this._isAuthenticated;
	}

	async signIn(state) {
		try {
			const response = await axios.post('/api/auth/login', {
				email: state.email,
				password: state.password
			}, {
				headers: {
					'Content-Type': 'application/json'
				}
			});

			this.updateState(response.data);
			return this.success(state);
		} catch (error) {
			console.error('Error:', error);
			throw error;
		}
	}

	async signOut(state) {
		try {
			await axios.post('api/auth/logout');
			this.updateState(undefined);
			return this.success(state);
		} catch (popupSignOutError) {
			console.log("Popup signout error: ", popupSignOutError);
			try {
				await this.userManager.signoutRedirect(this.createArguments(state));
				return this.redirect();
			} catch (redirectSignOutError) {
				console.log("Redirect signout error: ", redirectSignOutError);
				return this.error(redirectSignOutError);
			}
		}
	}

	updateState(user) {
		this._user = user;
		this._isAuthenticated = !!this._user;
		this.notifySubscribers();
	}

	subscribe(callback) {
		this._callbacks.push({ callback, subscription: this._nextSubscriptionId++ });
		return this._nextSubscriptionId - 1;
	}

	unsubscribe(subscriptionId) {
		const subscriptionIndex = this._callbacks
			.map((element, index) => element.subscription === subscriptionId ? { found: true, index } : { found: false })
			.filter(element => element.found === true);
		if (subscriptionIndex.length !== 1) {
			throw new Error(`Found an invalid number of subscriptions ${subscriptionIndex.length}`);
		}

		this._callbacks.splice(subscriptionIndex[0].index, 1);
	}

	notifySubscribers() {
		for (let i = 0; i < this._callbacks.length; i++) {
			const callback = this._callbacks[i].callback;
			callback();
		}
	}

	createArguments(state) {
		return { useReplaceToNavigate: true, data: state };
	}

	error(message) {
		return { status: AuthenticationResultStatus.Fail, message };
	}

	success(state) {
		return { status: AuthenticationResultStatus.Success, state };
	}

	redirect() {
		return { status: AuthenticationResultStatus.Redirect };
	}

	static get instance() { return authService }
}

const authService = new AuthorizeService();

export default authService;

export const AuthenticationResultStatus = {
	Redirect: 'redirect',
	Success: 'success',
	Fail: 'fail'
};
